package com.cybergstudios.rtc.world

import com.cybergstudios.rtc.engine.Color
import com.cybergstudios.rtc.math.Vec2

data class Ball(
    var x: Double = 0.0,
    var y: Double = -80.0,
    val radius: Double = 4.0,
    val color: Color = Color(102.0, 178.0, 255.0, 1.0),
    var vel: Vec2 = Vec2(0.0, -0.2),
) {
    fun resetVel() {
        vel = Vec2(0.0, -0.2)
    }

    fun invertVelX() {
        vel.x *= -1.0
    }

    fun updateX(x: Double) { this.x = x }

    fun integrate(delta: Double) {
        val curPos = Vec2(x, y)
        val newPos = curPos.add(this.vel.scale(delta))
        this.x = newPos.x
        this.y = newPos.y
    }

    fun left(): Double = x - radius
    fun right(): Double = x + radius
    fun top(): Double = y + radius
    fun bottom(): Double = y - radius
}
